import { useEffect, useState } from 'react';
import { useRef } from 'react';
import styled, { keyframes } from 'styled-components';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const SvgLine = () => {
  const [width, setWidth] = useState(0);
  const location = useLocation();
  const svg = useRef();
  const color = useSelector(state => state.colorSlice.value);
  const path = (y) => `path("M 0 10 Q ${width / 2} ${y}, ${width} 10")`;
  useEffect(() => {
    if(location.pathname.includes("contact")){
      setWidth(svg.current.clientWidth);
      window.addEventListener('resize', () => setWidth(svg.current.clientWidth));
    }
  }, [location]);
  return (
    <Svg color={color} ref={svg} path={path} w={width} xmlns="http://www.w3.org/2000/svg">
      <path strokeWidth={2} fill="transparent" />
      <circle cx="50" cy="50" r="2" fill="#0f0" />
    </Svg>
  )
}

export default SvgLine;

const pathAnimate = (props) => keyframes`
  0% {
    d: ${props.path(10)};
  }
  33% {
    d: ${props.path(30)};
  }
  50% {
    d: ${props.path(30)};
  }
  67% {
    d: ${props.path(-10)};
  }
  100% {
    d: ${props.path(10)};
  }
`;

const Svg = styled.svg`
  width: 100%;
  height: 22px;
  position: absolute;
  bottom: 0px;
  left: 0;
  pointer-events: none;
  path {
    stroke: white;
    d: ${props => props.path(10)};
    transition: stroke 0.3s ease-in;
    &.active {
      animation: ${props => pathAnimate(props)} 0.8s ease-out forwards;
      stroke: ${props => props.color};
    }
  }
`;